import { ApiService } from '../../app-lite/api/api.service';

import PriceMatrixSettingsHtml from '../../app-lite/price-matrix/price-matrix.settings.html';

export function PriceMatrixStates (
   $stateProvider : ng.ui.IStateProvider
) {
	$stateProvider
	.state({
		controller : 'PriceMatrixSettingsCtrl',
		name			 : 'app.price-matrix',
		templateUrl: PriceMatrixSettingsHtml,
    url				 : '/price_matrix',
		resolve		 : {
			matrices: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/price_matrices')
		}
	});
}